/**
 * Pin Google Merchant "Top Quality Store" badge. Google sets inline
 * !important left/bottom on #google-merchantwidget-iframe-wrapper, so we
 * re-apply via JS. Desktop: centered just above the sticky footbar Add to
 * Cart button. Mobile: flush against the right edge so it can't overlap the
 * footbar controls.
 *
 * Also parks the Redeemly "Store Credit" launcher (open shadow root
 * #mcb-launcher-widget-root): the app positions it bottom-left 100px up,
 * which stacks it on the Google badge and over product photos. On mobile it
 * is pinned bottom-left at one third of the viewport height; on desktop it
 * stays flush bottom-left, lifted above the PDP footbar while that is visible.
 */
(function () {
  var ID = 'google-merchantwidget-iframe-wrapper';
  var RD_ROOT = 'mcb-launcher-widget-root';
  var FOOTBAR_SEL = '.js-footbar-product.footbar-product--visible';
  var BUTTON_SEL = '.js-footbar-product.footbar-product--visible .footbar-product__button-add-to-cart .btn--footbar, .js-footbar-product.footbar-product--visible .btn--footbar';
  var BADGE_SIZE = 56;
  var GAP = 8;
  var applying = false;
  var lastLeft = '';
  var lastBottom = '';
  var raf = 0;
  var obs = null;
  var observed = null;

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getAnchorButton() {
    return document.querySelector(BUTTON_SEL);
  }

  function computePosition(button) {
    var rect = button.getBoundingClientRect();
    var left = Math.round(rect.left + rect.width / 2 - BADGE_SIZE / 2);
    var maxLeft = Math.max(8, window.innerWidth - BADGE_SIZE - 8);
    left = Math.min(Math.max(8, left), maxLeft);
    var bottom = Math.round(window.innerHeight - rect.top + GAP);
    bottom = Math.max(GAP, bottom);
    return {
      left: left + 'px',
      bottom: bottom + 'px'
    };
  }

  function apply(el, left, bottom) {
    if (!el || applying) return;
    if (left === lastLeft && lastBottom === bottom &&
        el.style.getPropertyValue('left') === left &&
        el.style.getPropertyValue('bottom') === bottom) {
      return;
    }
    applying = true;
    el.style.setProperty('left', left, 'important');
    el.style.setProperty('bottom', bottom, 'important');
    lastLeft = left;
    lastBottom = bottom;
    applying = false;
  }

  function observeBadge(badge) {
    if (observed === badge) return;
    if (obs) obs.disconnect();
    observed = badge;
    obs = new MutationObserver(schedule);
    obs.observe(badge, { attributes: true, attributeFilter: ['style', 'class'] });
    var footbar = document.querySelector('.js-footbar-product');
    if (footbar) obs.observe(footbar, { attributes: true, attributeFilter: ['class'] });
  }

  function mobileLeft(badge) {
    var w = (badge && badge.offsetWidth) || BADGE_SIZE;
    return Math.max(GAP, window.innerWidth - w - GAP) + 'px';
  }

  var rdObs = null;
  var rdObserved = null;
  var rdShadowObserved = null;
  var popupObserved = null;
  var fvObserved = null;
  var fvFootbarObserved = null;

  /* On mobile the floating video is fixed bottom-right ~76px up, which puts
   * it on top of the sticky product footbar (size buttons) whenever that is
   * visible. Lift it above the footbar (and above the Google badge that
   * already sits on the footbar), and hide it while a popup drawer is open. */
  function placeVideo() {
    var v = document.querySelector('.product-floating-video');
    if (!v) return;
    if (fvObserved !== v) {
      fvObserved = v;
      new MutationObserver(schedule).observe(v, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    var footbarEl = document.querySelector('.js-footbar-product');
    if (footbarEl && footbarEl !== fvFootbarObserved) {
      fvFootbarObserved = footbarEl;
      new MutationObserver(schedule).observe(footbarEl, { attributes: true, childList: true, subtree: true });
    }
    if (document.querySelector('[data-js-popup-name].show')) {
      if (v.style.getPropertyValue('display') !== 'none') {
        v.style.setProperty('display', 'none', 'important');
      }
      return;
    }
    if (v.style.getPropertyValue('display') === 'none') {
      v.style.removeProperty('display');
    }
    if (window.innerWidth >= 768 || !isVisible(v)) {
      v.style.removeProperty('bottom');
      return;
    }
    var bottom = 76;
    var footbar = document.querySelector(FOOTBAR_SEL);
    if (isVisible(footbar)) {
      bottom = Math.round(window.innerHeight - footbar.getBoundingClientRect().top + GAP);
      var badge = document.getElementById(ID);
      if (isVisible(badge)) bottom += badge.offsetHeight + GAP;
    }
    var bottomPx = bottom + 'px';
    if (v.style.getPropertyValue('bottom') !== bottomPx || v.style.getPropertyPriority('bottom') !== 'important') {
      v.style.setProperty('bottom', bottomPx, 'important');
    }
  }


  function placeRedeemly() {
    var root = document.getElementById(RD_ROOT);
    if (!root || !root.shadowRoot) return;
    if (rdShadowObserved !== root.shadowRoot) {
      rdShadowObserved = root.shadowRoot;
      new MutationObserver(schedule).observe(root.shadowRoot, { childList: true, subtree: true });
    }
    var btn = root.shadowRoot.querySelector('.launcher__floating-button');
    if (!btn) return;
    if (rdObserved !== btn) {
      if (rdObs) rdObs.disconnect();
      rdObserved = btn;
      rdObs = new MutationObserver(schedule);
      rdObs.observe(btn, { attributes: true, attributeFilter: ['style'] });
    }
    /* A full-screen popup (nav drawer, cart, quick-view…) is open — the
     * launcher must not sit on top of it. */
    var popupEl = document.querySelector('.js-popup');
    if (popupEl && popupEl !== popupObserved) {
      popupObserved = popupEl;
      new MutationObserver(schedule).observe(popupEl, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    var popupOpen = document.querySelector('[data-js-popup-name].show');
    if (popupOpen) {
      if (btn.style.getPropertyValue('display') !== 'none') {
        btn.style.setProperty('display', 'none', 'important');
      }
      return;
    }
    if (btn.style.getPropertyValue('display') === 'none') {
      btn.style.removeProperty('display');
    }
    var mobile = window.innerWidth < 768;
    var bottom = mobile ? Math.round(window.innerHeight / 3) : GAP;
    var footbar = document.querySelector(FOOTBAR_SEL);
    if (!mobile && isVisible(footbar)) {
      bottom = Math.max(GAP, Math.round(window.innerHeight - footbar.getBoundingClientRect().top + GAP));
    }
    var left = GAP + 'px';
    var bottomPx = bottom + 'px';
    if (btn.style.getPropertyValue('left') !== left || btn.style.getPropertyValue('bottom') !== bottomPx ||
        btn.style.getPropertyPriority('bottom') !== 'important') {
      btn.style.setProperty('left', left, 'important');
      btn.style.setProperty('bottom', bottomPx, 'important');
    }
  }

  function run() {
    placeRedeemly();
    placeVideo();
    var badge = document.getElementById(ID);
    if (!badge) return;
    observeBadge(badge);

    var mobile = window.innerWidth < 768;
    var button = getAnchorButton();
    if (!isVisible(button)) {
      if (mobile) apply(badge, mobileLeft(badge), GAP + 'px');
      return;
    }

    var pos = computePosition(button);
    /* Never let the badge dip inside the footbar: anchor to the footbar's
     * top edge (the button-anchored position overlaps the size/options row). */
    var footbarEl = document.querySelector(FOOTBAR_SEL);
    var bottomPx = isVisible(footbarEl)
      ? (Math.max(parseInt(pos.bottom, 10), Math.round(window.innerHeight - footbarEl.getBoundingClientRect().top + GAP)) + 'px')
      : pos.bottom;
    apply(badge, mobile ? mobileLeft(badge) : pos.left, bottomPx);
  }

  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(function () {
      raf = 0;
      run();
    });
  }

  run();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  }

  /* Google injects the badge iframe wrapper late (post-load, sometimes
   * seconds later). run() exits early while it's absent, so watch the DOM
   * for the insertion and re-position the moment it appears. */
  var bodyObs = new MutationObserver(function () {
    if (document.getElementById(ID) || document.getElementById(RD_ROOT)) schedule();
  });
  bodyObs.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
})();
